import {
  SET_DIMENSIONS,
} from './actions';

export default function(state = {}, action) {
  switch (action.type) {
    case SET_DIMENSIONS:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/dimensions/index.js